export const LEGAL_VERSION = "2026-10-03";
export const CONTROLLER = {
  legalName: "Tuti Representações e Consultoria Ltda. - ME",
  cnpj: "36.006.249/0001-51",
  address: "Avenida Nelci Gonçalves de Simas, 515, Centro, Naviraí - MS, CEP 79947-081",
  email: "contato@tuticonsultoria.com.br",
} as const;
